import { MUTATION_KEYS, QUERY_KEYS, LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { type AxiosError, type AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { EnterprisesService } from 'services/enterprises';
import { type AdminEnterprise, type CreateAdminEnterprisePayload } from 'types/enterprises';

export const useCreateAdmin = (): UseMutationResult<
  AxiosResponse<AdminEnterprise>,
  AxiosError,
  CreateAdminEnterprisePayload
> => {
  const queryClient = useQueryClient();
  const { hideDialog } = useDialogContext();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return useMutation({
    mutationKey: [MUTATION_KEYS.CREATE_ADMIN],
    mutationFn: async (payload: CreateAdminEnterprisePayload) =>
      await EnterprisesService.createAdmin(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_ADMINS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_ADMINS_COUNT] });
      toast.success(t('InsuranceAdministrators.addAdmin.success'));
      hideDialog();
    },
    onError: () => {
      toast.error(t('InsuranceAdministrators.addAdmin.error'));
    },
  });
};
